/**
 * File view.js.
 *
 * Handles logo list blocks.
 */
(function ($) {
    'use strict';
    $(document).ready(function () {
        checkLastRowItems();

        $(window).on('resize', function(){
            checkLastRowItems();
        });
    });

    function checkLastRowItems() {
        $('.locations-contact__boxes').each(function(){
            let totalItems = $(this).find('.locations-contact__box').length;
            if ( 0 < totalItems ) {
                let windowWidth = $(window).outerWidth();
                let itemsPerRow = 1;
                
                if ( 767 < windowWidth ) {
                    itemsPerRow = 2;
                }
                
                $(this).find('.locations-contact__box').removeClass('last-row-item');
                
                // Calculate the number of rows and items in the last row
                let itemsInLastRow = totalItems % itemsPerRow || itemsPerRow;

                // Calculate the starting index of the last row items
                let startIndex = totalItems - itemsInLastRow + 1;

                // Add a class to the last row items
                for (let i = startIndex; i <= totalItems; i++) {
                    $(this).find('.locations-contact__box:nth-child(' + i + ')').addClass('last-row-item');
                }
            }
        });
    }
})(jQuery);